import { Help, Info } from "@mui/icons-material";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { useTranslation } from "react-i18next";

import { useMortgageState } from "../../../../../contexts/mortgage/Reducer";
import MortgageTooltip from "../../../../tooltip/MortgageTooltip";
import { MortgageSummaryHeaderLabel } from "../../../2-summary/NewMortgageSummary";
import MortgageRowDesktop from "./MortgageRowDesktop";
import MortgageTotalDesktop from "./MortgageTotalDesktop";

const MortgageDetailSummaryDesktop = () => {
    const { t } = useTranslation();
    const { newMortgage, mortgage } = useMortgageState();

    return (
        <TableContainer component={Box} mt={"48px"}>
            <Table sx={{ minWidth: 650 }} aria-label="new mortgage table">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <MortgageSummaryHeaderLabel>{t("SummaryScreen.Financing")}</MortgageSummaryHeaderLabel>
                        </TableCell>
                        <TableCell>
                            <MortgageSummaryHeaderLabel>{t("SummaryScreen.Term")}</MortgageSummaryHeaderLabel>
                        </TableCell>
                        <TableCell align="right">
                            <MortgageSummaryHeaderLabel>
                                {t("General.Amount in", { currency: mortgage?.currency })}
                            </MortgageSummaryHeaderLabel>
                        </TableCell>
                        <TableCell align="right">
                            <MortgageSummaryHeaderLabel>
                                {t("General.Interest rate")}
                                <MortgageTooltip
                                    title={t(
                                        "ConfigurationScreen.Interest rates may change over the course of the next few days..."
                                    )}>
                                    <Help
                                        sx={{
                                            fontSize: "16px",
                                            color: "#0093D1",
                                            marginLeft: "4px",
                                            marginBottom: "1px",
                                        }}
                                    />
                                </MortgageTooltip>
                            </MortgageSummaryHeaderLabel>
                        </TableCell>
                        <TableCell align="right">
                            <MortgageSummaryHeaderLabel>
                                {t("General.Monthly charge in", { currency: mortgage?.currency })}
                                <MortgageTooltip title={t("General.This calculation is indicative and is based on...")}>
                                    <Info
                                        sx={{
                                            fontSize: "16px",
                                            color: "#0093D1",
                                            marginLeft: "4px",
                                            marginBottom: "1px",
                                        }}
                                    />
                                </MortgageTooltip>
                            </MortgageSummaryHeaderLabel>
                        </TableCell>
                    </TableRow>
                </TableHead>
                {newMortgage && (
                    <MortgageRowDesktop mortgage={newMortgage} isNew={true} key={`mortgage-${newMortgage.id}`} />
                )}
                {newMortgage?.otherLiabilities &&
                    newMortgage.otherLiabilities
                        .filter((otherMortgage) => otherMortgage.amount > 0)
                        .map((otherMortgage, index) => (
                            <MortgageRowDesktop
                                mortgage={otherMortgage}
                                isNew={false}
                                key={`other-mortgage-${index}`}
                            />
                        ))}
                <MortgageTotalDesktop newMortgage={newMortgage} />
            </Table>
        </TableContainer>
    );
};
export default MortgageDetailSummaryDesktop;
